










































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable class-methods-use-this */
/* eslint-disable prefer-const */

import {
  Component, Vue,
} from 'vue-property-decorator';

import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import dayjs from 'dayjs';
import { DateRange } from '@/components/DatePickerWtoday.vue';
import FormInput from '@/components/FormInput.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import SingleDatePickerNoTP from '@/components/SingleDatePickerNoTP.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import PlayIcon from 'mdi-vue/Play';

import { api2 } from '@/libs/api';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

@Component({
  components: {
    LayoutContent,
    Button,
    FormInput,
    SearchField,
    Select,
    SingleDatePickerNoTP,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Checkbox,
    PlayIcon,
  },
})

export default class ProcessTable extends Vue {
  $refs!: {
    'file-input': HTMLInputElement;
  }

  token = '';

  dataDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  periodDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  dataDateFormat = 'DD/MM/YYYY';
  periodDateFormat = 'MM/YYYY';

  optionProcessType = [{}];

  // selectedProcessType: any = '';

  selectedCheckAll = false;
  selectedProcessTypeAny: any = {};

  file: File | null = null;

  mounted() {
    this.token = JSON.parse(localStorage.getItem('USER') || '{}').token;
    this.getJobList();
  }

  async getJobList() {
    const jobTypeList = await api2.post('/recon/job/list/RECON_PROCESS', {});
    this.optionProcessType = [];
    jobTypeList.data.data.forEach((item: any) => {
      let tmpOptFileType = {
        label: item.job_description,
        value: item.job_code,
        jobNo: item.job_no,
      };
      this.optionProcessType.push(tmpOptFileType);
    });
    this.resetForm();
    this.dataDate.startDate = dayjs(jobTypeList.data.currDate, 'YYYY-MM-DD').toDate().toString();
    this.periodDate.startDate = dayjs(jobTypeList.data.currDate, 'YYYY-MM-DD').toDate().toString();
  }

  onChangeCheckAll() {
    // console.log(this.selectedCheckAll);
    this.optionProcessType.forEach((row: any) => {
      this.selectedProcessTypeAny[row.value] = this.selectedCheckAll;
    });
  }

  async onFileInput(event: Event) {
    this.file = null;
    const target = event.target as HTMLInputElement;
    const { files } = target;
    if (files === null || files.length === 0) return;
    const file = files[0];
    this.file = file;
  }

  async process() {
    try {
      let selectedProcessTypeKeys = Object.values(this.selectedProcessTypeAny);
      let isProcessTypeNotEmpty = false;
      selectedProcessTypeKeys.forEach((values) => {
        if (values) {
          isProcessTypeNotEmpty = true;
        }
      });

      // if (!this.dataDate.startDate || !this.periodDate.startDate || !this.selectedProcessType.value) {
      if (!this.dataDate.startDate || !this.periodDate.startDate) {
        showToast(ToastType.FAILED, 'Oops... Sorry', 'Please Complete All Forms');
        return;
      }

      if (!selectedProcessTypeKeys || selectedProcessTypeKeys.length === 0 || !isProcessTypeNotEmpty) {
        showToast(ToastType.FAILED, 'Oops... Sorry', 'Please Select Process');
        return;
      }

      let formData = new FormData();
      // formData.append('dataDate', this.dataDate.startDate);
      // formData.append('periodDate', this.periodDate.startDate);
      formData.append('dataDate', dayjs(this.dataDate.startDate).format('YYYY-MM-DD'));
      formData.append('periodDate', dayjs(this.periodDate.startDate).format('YYYY-MM-DD'));
      // formData.append('processType', this.selectedProcessType.value);
      formData.append('processType', JSON.stringify(this.selectedProcessTypeAny));
      if (this.file !== null) {
        formData.append('file', this.file);
      }

      await api2.post('/recon/job/process', formData, {});

      showToast(ToastType.SUCCESS, 'Congratulations',
        'Reconciliation process executed successfully, please check the progress in history');
      this.resetForm();
    } catch (error) {
      showToast(ToastType.FAILED, 'Opps... Sorry', 'Problem connection, Please check your internet connection');
    }
  }

  resetForm() {
    this.dataDate.startDate = null;
    this.dataDate.endDate = null;
    this.periodDate.startDate = null;
    this.periodDate.endDate = null;
    this.selectedCheckAll = false;
    this.onChangeCheckAll();
  }
}
